<template>
    <div id="main">
        <div class="page">
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('detalhes') }}
                        </h1>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="$emit('voltar', true)"
                        >
                            {{ $t('voltar') }}
                        </button>
                    </div>
                </div>
                <ul class="nav nav-tabs nav-tabs-children">
                    <li
                        v-for="(aba, i) in abas"
                        :key="i"
                        v-show="true"
                        :class="{ active: abaSelecionada == i }"
                        @click="changeTab(i)"
                    >
                        <a data-toggle="tab">{{ $t(aba) }}</a>
                    </li>
                </ul>
                <b-dropdown aria-role="list" class="mobile-tab-list">
                    <div slot="trigger" class="mobile-tab">
                        <span class="mobile-tab-text">
                            {{ $t(abas[abaSelecionada]) }}
                        </span>
                        <em class="mdi mdi-chevron-down"></em>
                    </div>
                    <b-dropdown-item
                        class="mobile-tab-list-item"
                        :class="{ active: abaSelecionada == i }"
                        aria-role="listitem"
                        v-for="(aba, i) in abas"
                        v-show="true"
                        :key="i"
                        @click="changeTab(i)"
                    >
                        {{ $t(aba) }}
                    </b-dropdown-item>
                </b-dropdown>
                <Geral
                    ref="tabGeral"
                    v-if="abasAbertas['geral']"
                    v-show="abas[abaSelecionada] == 'geral'"
                    :data="geralData"
                />
                <Grade
                    ref="tabGrade"
                    v-if="hasGrade && abasAbertas['grade']"
                    v-show="abas[abaSelecionada] == 'grade'"
                    :data="gradeData"
                    :isEmpty="!hasGrade"
                />
            </div>
        </div>
    </div>
</template>

<script>

import Geral from '@/components/vendas/detalhes/abas/Geral.vue'
import Grade from '@/components/vendas/detalhes/abas/Grade.vue'

export default {
    name: 'DetalhesManage',
    components: {
        Geral,
        Grade,
    },
    props: {
        cameFrom: {
            type: String,
            default: 'route',
        },
        geralData: Object,
        gradeData: Array,
        hasGrade: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            abaSelecionada: 0,
            abas: null,
            abasAbertas: {},
        };
    },
    created() {
        this.configTab();
        this.abasAbertas['geral'] = true;
    },
    methods: {
        configTab() {
            if (this.hasGrade) {
                this.abas = ['geral', 'grade'];
            } else {
                this.abas = ['geral'];
            }
        },
        changeTab(i) {
            this.abaSelecionada = i;
            this.abasAbertas[this.abas[this.abaSelecionada]] = true;
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px 20px;
    height: 100%;

    .page {
        position: relative;

        .listing-header {
            padding-bottom: 20px;
        }

        .nav-tabs-children {
            margin-bottom: 20px;
            li > ::after {
                bottom: -4px;
                border-width: 2px;
            }
        }
        .mobile-tab {
            cursor: pointer;

            &-list {
                width: calc(100% + 40px);
                margin-top: 20px;
                margin-bottom: 20px;
                margin-left: -20px;
                padding-right: 20px;
                padding-bottom: 5px;
                padding-left: 20px;
                border-bottom: 1px solid $table-border;
                justify-content: center;

                &::after {
                    content: '';
                    border: 3px solid $primary-color-click;
                    border-radius: 100px;
                    position: absolute;
                    width: calc(100% - 40px);
                    bottom: -3px;
                }

                &-item {
                    text-transform: uppercase;
                    font-weight: 600;
                    color: $text-color;

                    &.active {
                        color: $primary-color-click;
                    }
                }
            }

            &-text {
                text-transform: uppercase;
                font-weight: 600;
                color: $primary-color-click;

                & ~ i {
                    color: $primary-color-click;
                }
            }
        }
    }

    @media only screen and (max-width: 760px) {
        .nav.nav-tabs-main {
            display: flex;
            justify-content: center;
            padding: 0;
            margin: 0;

            &::after {
                display: none;
            }
        }

        .nav.nav-tabs.nav-tabs-children {
            display: none;
        }
    }

    @media only screen and (min-width: 761px) {
        .mobile-tab-list {
            display: none;
        }
    }
}
</style>
